import { render } from "./MyPublications.vue?vue&type=template&id=2de2a9c6&scoped=true"
import script from "./MyPublications.vue?vue&type=script&lang=js"
export * from "./MyPublications.vue?vue&type=script&lang=js"

import "./MyPublications.vue?vue&type=style&index=0&id=2de2a9c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2de2a9c6"]])

export default __exports__